
import React, { useState } from 'react';
import './HomePage.css';
import { useApp } from '../../context/AppContext';
import Stories from '../../components/Stories/Stories';
import PostCard from '../../components/PostCard/PostCard';
import CreatePostModal from '../../components/CreatePostModal/CreatePostModal';

const HomePage: React.FC = () => {
  const { posts, adminUser, currentUser, subscribe, subscriptionTiers, isAdminView } = useApp();
  const [showCreatePost, setShowCreatePost] = useState(false);
  const regularPosts = posts.filter(p => !p.isStory).sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime());

  if (!currentUser.isSubscribed && !isAdminView) {
    return (
      <div className="subscribe-gate">
        <div className="gate-header">
          <img src={adminUser.avatar} alt={adminUser.displayName} className="gate-avatar" />
          <h1>{adminUser.displayName}</h1>
          <p className="gate-bio">{adminUser.bio}</p>
          <div className="gate-stats">
            <div className="gate-stat">
              <span className="stat-value">{(adminUser.subscribers / 1000).toFixed(1)}K</span>
              <span className="stat-label">Fans</span>
            </div>
            <div className="gate-stat">
              <span className="stat-value">{adminUser.posts}</span>
              <span className="stat-label">Posts</span>
            </div>
            <div className="gate-stat">
              <span className="stat-value">{(adminUser.likes / 1000000).toFixed(1)}M</span>
              <span className="stat-label">Likes</span>
            </div>
          </div>
        </div>

        <div className="subscription-tiers">
          <h2>Unlock All Content</h2>
          <p className="subscription-subtitle">Subscribe now for unlimited access to exclusive photos & videos</p>
          {subscriptionTiers.map(tier => {
            const getPeriodLabel = (id: string) => {
              switch(id) {
                case 'monthly': return '/month';
                case 'quarterly': return '/3 months';
                case 'yearly': return '/year';
                case 'lifetime': return ' one-time';
                default: return '';
              }
            };
            return (
              <div key={tier.id} className={`tier-card ${tier.isPopular ? 'popular' : ''} ${tier.id === 'lifetime' ? 'lifetime' : ''}`}>
                {tier.isPopular && <span className="popular-badge">MOST POPULAR</span>}
                {tier.id === 'lifetime' && <span className="popular-badge best-value">BEST VALUE</span>}
                <div className="tier-header">
                  <h3>{tier.name}</h3>
                  <div className="tier-price">
                    <span className="price">${tier.price}</span>
                    <span className="period">{getPeriodLabel(tier.id)}</span>
                  </div>
                </div>
                <ul className="tier-features">
                  {tier.features.map((feature, i) => (
                    <li key={i}>
                      <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
                <button className="subscribe-btn" onClick={() => subscribe(tier.id)}>
                  Subscribe Now
                </button>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="home-page">
      <Stories />
      
      {isAdminView && (
        <div className="create-post-bar" onClick={() => setShowCreatePost(true)}>
          <img src={adminUser.avatar} alt={adminUser.displayName} className="create-avatar" />
          <span className="create-placeholder">Share something with your subscribers...</span>
          <button className="create-post-btn">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
          </button>
        </div>
      )}
      
      <div className="creator-banner">
        <img src={adminUser.coverImage} alt="Cover" className="banner-bg" />
        <div className="banner-content">
          <img src={adminUser.avatar} alt={adminUser.displayName} className="banner-avatar" />
          <div className="banner-info">
            <h2>{adminUser.displayName} <svg className="verified" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg></h2>
            <p>{adminUser.subscribers.toLocaleString()} subscribers</p>
          </div>
        </div>
      </div>
      
      <div className="feed">
        {regularPosts.map(post => (
          <PostCard key={post.id} post={post} />
        ))}
      </div>
      
      {showCreatePost && <CreatePostModal onClose={() => setShowCreatePost(false)} />}
    </div>
  );
};

export default HomePage;
